module.exports = __webpack_public_path__ + "static/media/Thee-fairtrade-2.ede2ca15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Thee-fairtrade-2.jpg
// module id = 327
// module chunks = 0